import React, {SyntheticEvent} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

interface IProps {
    iconPrev: JSX.Element;
    iconNext: JSX.Element;
    pageCount: number;
    currentPage: number;
    onChangePageClick?: (page: number) => void;
    handlePrevClick?: () => void;
    handleNextClick?: () => void;
    hrefBuilder?: (page: number) => string;
}

interface INavigationButton {
    isDisabled: boolean;
    theme?: Theme;
}

export const PaginationWithCounter = (props: IProps) => {
    const renderPrevButton = () => {
        const prevPageNumber = props.currentPage - 1 || 1;
        const prevPageLink = props.hrefBuilder && props.hrefBuilder(prevPageNumber);
        const isDisabled = props.currentPage <= 1;

        const onClick = (e: SyntheticEvent) => {
            if (props.onChangePageClick) {
                props.onChangePageClick(prevPageNumber);
                e.preventDefault();
            }

            if (props.handlePrevClick) {
                props.handlePrevClick();
                e.preventDefault();
            }

            return false;
        };

        return (
            <NavigationButton href={isDisabled ? "" : prevPageLink} onClick={onClick} rel="prev" isDisabled={isDisabled}>
                {props.iconPrev}
            </NavigationButton>
        );
    };

    const renderNextButton = () => {
        const nextPageNumber = props.currentPage + 1;
        const nextPageLink = props.hrefBuilder && props.hrefBuilder(nextPageNumber);
        const isDisabled = props.currentPage >= props.pageCount;

        const onClick = (e: SyntheticEvent) => {
            if (props.onChangePageClick) {
                props.onChangePageClick(nextPageNumber);
                e.preventDefault();
            }

            if (props.handleNextClick) {
                props.handleNextClick();
                e.preventDefault();
            }

            return false;
        };

        return (
            <NavigationButton href={isDisabled ? "" : nextPageLink} onClick={onClick} rel="next" isDisabled={isDisabled}>
                {props.iconNext}
            </NavigationButton>
        );
    };

    return (
        <div css={navigationHolder}>
            {renderPrevButton()}
            <span css={navigationCounter}>
                {props.currentPage}/{props.pageCount}
            </span>
            {renderNextButton()}
        </div>
    );
};

const navigationHolder = (theme: Theme) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 4.4rem;
    font-size: 1.4rem;

    @media (min-width: ${theme?.breakpoints?.md || "1024px"}) {
        justify-content: center;
        font-size: 1.2rem;
        padding: 0;
        color: #fff;
    }
`;

const NavigationButton = styled.a<INavigationButton>`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    border: none;
    text-decoration: none !important;

    span {
        display: none;
    }

    @media (min-width: ${(props) => props.theme?.breakpoints?.md || "1024px"}) {
        width: 13.5rem;
        height: 4.2rem;
        color: #fff;
        font-size: 1.2rem;
        border: 1px solid ${(props) => props.theme?.colors?.gray?.[700] || "#7b7b81"};
        border-radius: 0.4rem;

        span {
            display: inline-block;
            color: #fff;
        }

        &:hover,
        &:active,
        &:focus {
            background-color: #ececec;

            span {
                color: ${(props) => props.theme?.colors?.secondary || "#23232d"};
            }

            svg {
                fill: ${(props) => props.theme?.colors?.secondary || "#23232d"};
            }
        }
    }

    ${(props) =>
        props.isDisabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`;

const navigationCounter = (theme: Theme) => css`
    @media (min-width: ${theme?.breakpoints?.md || "1024px"}) {
        padding: 0 2rem;
    }
`;
import React, {SyntheticEvent} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

interface IProps {
    iconPrev: JSX.Element;
    iconNext: JSX.Element;
    pageCount: number;
    currentPage: number;
    onChangePageClick?: (page: number) => void;
    handlePrevClick?: () => void;
    handleNextClick?: () => void;
    hrefBuilder?: (page: number) => string;
}

interface INavigationButton {
    isDisabled: boolean;
    theme?: Theme;
}

export const PaginationWithCounter = (props: IProps) => {
    const renderPrevButton = () => {
        const prevPageNumber = props.currentPage - 1 || 1;
        const prevPageLink = props.hrefBuilder && props.hrefBuilder(prevPageNumber);
        const isDisabled = props.currentPage <= 1;

        const onClick = (e: SyntheticEvent) => {
            if (props.onChangePageClick) {
                props.onChangePageClick(prevPageNumber);
                e.preventDefault();
            }

            if (props.handlePrevClick) {
                props.handlePrevClick();
                e.preventDefault();
            }

            return false;
        };

        return (
            <NavigationButton href={isDisabled ? "" : prevPageLink} onClick={onClick} rel="prev" isDisabled={isDisabled}>
                {props.iconPrev}
            </NavigationButton>
        );
    };

    const renderNextButton = () => {
        const nextPageNumber = props.currentPage + 1;
        const nextPageLink = props.hrefBuilder && props.hrefBuilder(nextPageNumber);
        const isDisabled = props.currentPage >= props.pageCount;

        const onClick = (e: SyntheticEvent) => {
            if (props.onChangePageClick) {
                props.onChangePageClick(nextPageNumber);
                e.preventDefault();
            }

            if (props.handleNextClick) {
                props.handleNextClick();
                e.preventDefault();
            }

            return false;
        };

        return (
            <NavigationButton href={isDisabled ? "" : nextPageLink} onClick={onClick} rel="next" isDisabled={isDisabled}>
                {props.iconNext}
            </NavigationButton>
        );
    };

    return (
        <div css={navigationHolder}>
            {renderPrevButton()}
            <span css={navigationCounter}>
                {props.currentPage}/{props.pageCount}
            </span>
            {renderNextButton()}
        </div>
    );
};

const navigationHolder = (theme: Theme) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 4.4rem;
    font-size: 1.4rem;

    @media (min-width: ${theme?.breakpoints?.md || "1024px"}) {
        justify-content: center;
        font-size: 1.2rem;
        padding: 0;
        color: #fff;
    }
`;

const NavigationButton = styled.a<INavigationButton>`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    border: none;
    text-decoration: none !important;

    span {
        display: none;
    }

    @media (min-width: ${(props) => props.theme?.breakpoints?.md || "1024px"}) {
        width: 13.5rem;
        height: 4.2rem;
        color: #fff;
        font-size: 1.2rem;
        border: 1px solid ${(props) => props.theme?.colors?.gray?.[700] || "#7b7b81"};
        border-radius: 0.4rem;

        span {
            display: inline-block;
            color: #fff;
        }

        &:hover,
        &:active,
        &:focus {
            background-color: #ececec;

            span {
                color: ${(props) => props.theme?.colors?.secondary || "#23232d"};
            }

            svg {
                fill: ${(props) => props.theme?.colors?.secondary || "#23232d"};
            }
        }
    }

    ${(props) =>
        props.isDisabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`;

const navigationCounter = (theme: Theme) => css`
    @media (min-width: ${theme?.breakpoints?.md || "1024px"}) {
        padding: 0 2rem;
    }
`;
